import { z } from 'zod';
import { optionalMongoObjectId } from '../object-id-helpers.js';

export const CreateTicketCategorySchema = z.object({
    name: z.string().min(1),
    code: z.string().optional(),
    description: z.string().optional(),
    color: z.string().optional(),
    icon: z.string().optional(),
    parentId: optionalMongoObjectId,
    defaultSla: optionalMongoObjectId,
    defaultAssignmentTemplate: optionalMongoObjectId,
    defaultAssigneePool: z.array(z.object({
        type: z.enum(['title', 'user', 'unit', 'role']),
        value: z.string().min(1),
        label: z.string().optional(),
    }).passthrough()).optional(),
    requiresApproval: z.boolean().optional(),
    allowPublicSubmission: z.boolean().optional(),
    orderIndex: z.number().optional(),
    status: z.enum(['active', 'inactive']).optional(),
}).passthrough();

export const UpdateTicketCategorySchema = CreateTicketCategorySchema.partial();
